<template>
  <VCleaveInput
    v-bind="$attrs"
    hide-details="auto"
    dense
    v-on="$listeners"
    :options="options"
    :loading="loading"
  />
</template>

<script>
import VCleaveInput from "vuetify-cleave";
import axios from "axios";

export default {
  components: { VCleaveInput },
  data: () => ({
    loading: false,
    options: {
      delimiters: [".", ".", "-"],
      blocks: [2, 3, 3, 1],
      uppercase: true,
    },
  }),
};
</script>